export function setupClearIconTabIndex() {
    const setAccessibility  = (el) => {
        if (el.tabIndex !== 0) el.tabIndex = 0;

        if (el.getAttribute('aria-label') !== 'Clear entry') {
            el.setAttribute('aria-label', 'Clear entry');
        }
    }

    const updateAll = () => {
        document
            .querySelectorAll('.ant-input-clear-icon')
            .forEach(setAccessibility )
    }

    updateAll();
    const observer = new MutationObserver(updateAll)
    observer.observe(document.body, {
        childList: true,
        subtree:  true,
    });

    return observer;
}

